/**
 * @file payments-constants.ts
 *
 * Domain constants for the Payments & VAT feature: the stable gateway ids the
 * overview and sub-pages key on, the Shore Pay / Stripe terms links, and the
 * payment-method logos shown on the Shore Pay card.
 */

import type { PayIconName } from '@group.one/gravity';

/** Gateway id for the manual (cash-on-delivery) payment option. */
export const MANUAL_GATEWAY_ID = 'cod';

/** Gateway id for Shore Pay. */
export const SHORE_GATEWAY_ID = 'shore';

/** Terms links shown on the Connect with Shore Pay form. */
export const SHORE_PAY_TERMS_URL = 'https://www.one.com/en-gb/legal/terms/';
export const STRIPE_TERMS_URL = 'https://stripe.com/gb/legal/connect-account';

/** Payment-method logos shown on the Shore Pay card (Gravity pay-icon names). */
export const PAYMENT_METHOD_ICONS: PayIconName[] = [
  'visa',
  'mastercard-light',
  'maestro-light',
  'amex',
  'google-pay',
  'apple-pay',
];
